import React, { useState } from "react";
import { Card } from "react-bootstrap";
import WheelCard from "./WheelCard";
import edit from "@assets/images/edit.svg";
import ChartImg from "@assets/images/Frame 634 ai.svg";

export default function MainCard({
  mainImg,
  name,
  wheels,
  onDeleteWheelPress = () => {},
  wheelType,
  deletingWheelId = null,
  isPublic = false,
  isPrivate = false,
  onMakePrimaryPress = () => {},
  onMakePublicPrivatePress = () => {},
  isEditable = true,
  handleCloneWheel,
}) {
  const [openDropdownId, setOpenDropdownId] = useState(null);

  // Function to handle dropdown toggle
  const toggleDropdown = (id) => {
    if (openDropdownId === id) {
      setOpenDropdownId(null); // Close the dropdown if it's already open
    } else {
      setOpenDropdownId(id); // Open the dropdown for the clicked item
    }
  };

  return (
    <>
      <Card style={{ borderRadius: "31px", marginTop: "23px" }}>
        <Card.Body>
          <div className="row">
            <div className="col-lg-12">
              <div style={{ display: "flex", alignItems: "center" }}>
                <img src={mainImg} alt="Main img" />
                <Card.Title style={{ paddingLeft: "8px", paddingTop: "5px" }}>
                  {name}{" "}
                  <span
                    style={{
                      fontSize: "14px",
                      fontWeight: "400px",
                      fontFamily: "DM Sans",
                    }}
                  >
                    ({wheels?.length}/40 Wheel{wheels?.length > 1 ? "s" : null})
                  </span>
                </Card.Title>
              </div>
            </div>
          </div>

          <Card.Text style={{ paddingBottom: "14px" }}>
            <div className="row" style={{ paddingTop: "20px" }}>
              {wheels?.map((e, index) => (
                <div className="col-lg-3" key={e + index}>
                  <WheelCard
                    deletingWheelId={deletingWheelId}
                    wheelType={wheelType}
                    onDeleteWheelPress={onDeleteWheelPress}
                    onMakePrimaryPress={onMakePrimaryPress}
                    likeicon={edit}
                    chart={ChartImg}
                    mainName={e.wheel_name || "Wheel Name"}
                    authorName={e?.user_profile?.first_name}
                    item={e}
                    isPublic={isPublic}
                    isPrivate={isPrivate}
                    onMakePublicPrivatePress={onMakePublicPrivatePress}
                    isEditable={isEditable}
                    handleCloneWheel={handleCloneWheel}
                    toggleDropdown={toggleDropdown}
                    isDropDownOpen={openDropdownId === e?.id}
                  />
                </div>
              ))}
            </div>
          </Card.Text>
        </Card.Body>
      </Card>
    </>
  );
}
